/* eslint-disable import/prefer-default-export */
export enum NavigationType {
  ADD_CALCUL_LINK = 'Navigation/ADD_CALCUL_LINK',
  REMOVE_CALCUL_LINK = 'Navigation/REMOVE_CALCUL_LINK',
  CLEAR_CALCUL_LINK = 'Navigation/CLEAR_CALCUL_LINK'
}
